import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Alert,
} from "reactstrap";

// Actions
import { UserTypeAction } from "../../../store/actions";

// Import Breadcrumb
import Breadcrumbs from "../../../components/Layout/Breadcrumb";

// Import DeleteModal
import UserTypeModal from "./UserTypeForm";

// Import DeleteModal
import DeleteModal from "../../../components/Common/DeleteModal";

// Import DataTable
import DataTable from "../../../components/Common/DataTable";

import { getDataTableQuery } from "../../../helpers/functions_helper";

const breadcrumbItems = [
  {
    url: "/dashboard",
    label: "Dashboard",
    active: false,
  },
  {
    url: "#",
    label: "User Type",
    active: true,
  },
];

const AllUserType = (props: any) => {
  document.title = "User Type | " + process.env.REACT_APP_NAME;
  
  const [loader, setLoader] = useState(true);
  const dispatch = useDispatch();

  let {
    datatableData,
    datatableErrorMsg,
    createUserTypeSuccessMsg,
    createUserTypeErrorMsg,
    createUserTypeErrorData,
    updateUserTypeSuccessMsg,
    updateUserTypeErrorMsg,
    updateUserTypeErrorData,
    deleteUserTypeSuccessMsg,
    deleteUserTypeErrorMsg,
    deleteUserTypeErrorData,
    getUserTypeErrorMsg,
    loading,
  } = useSelector((state: any) => ({
    datatableData: state.UserType.GET_USER_TYPE_LIST_SUCCESS,
    datatableErrorMsg: state.UserType.GET_USER_TYPE_LIST_ERROR.message,

    createUserTypeSuccessMsg:
      state.UserType.CREATE_USER_TYPE_SUCCESS.message,
    createUserTypeErrorMsg:
      state.UserType.CREATE_USER_TYPE_ERROR.message,
    createUserTypeErrorData:
      state.UserType.CREATE_USER_TYPE_ERROR.data,

    updateUserTypeSuccessMsg:
      state.UserType.UPDATE_USER_TYPE_SUCCESS.message,
    updateUserTypeErrorMsg:
      state.UserType.UPDATE_USER_TYPE_ERROR.message,
    updateUserTypeErrorData:
      state.UserType.UPDATE_USER_TYPE_ERROR.data,

    deleteUserTypeSuccessMsg:
      state.UserType.DELETE_USER_TYPE_SUCCESS.message,
    deleteUserTypeErrorMsg:
      state.UserType.DELETE_USER_TYPE_ERROR.message,
    deleteUserTypeErrorData:
      state.UserType.DELETE_USER_TYPE_ERROR.data,

    getUserTypeErrorMsg: state.UserType.GET_USER_TYPE_ERROR.message,

    loading: state.UserType.loading,
  }));

  // DataTable ----------------------------------------------
  function renderHeaderHTML(column: any, colIndex: any) {
    return <span dangerouslySetInnerHTML={{ __html: column.text }} />;
  }
  function renderRowHTML(rowContent: any, row: any) {
    return <span dangerouslySetInnerHTML={{ __html: rowContent }} />;
  }

  const columns = [
    {
      dataField: "DT_RowIndex",
      text: "Sr. No.",
      sort: false,
      search: false,
    },
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   search: true,
    // },
    {
      dataField: "user_type_value_html",
      text: "User type",
      sort: true,
      search: true,
      formatter: renderRowHTML,
    },    
    {
      dataField: "action",
      text: "Action",
      sort: false,
      search: false,
      formatter: (rowContent: any, row: any): any => {
        return (
          <div className="d-flex gap-2 text-end">
            <Link 
              className="btn btn-pill btn-outline-primary btn-sm" 
              to="#"
              onClick={() => onClickEdit(row)}
            >
              <i className="fa-regular fa-pen-to-square"></i> Edit
            </Link>
            <Link
              className="btn btn-pill btn-outline-danger btn-sm"
              to="#"
              onClick={() => onClickDelete(row)}
            >
              <i className="fa-regular fa-trash-can"></i> Delete
            </Link>
          </div>
        );
      },
    },
  ];

  const [loadingListData, setLoadingListData] = useState(true);
  const [datatableOptions, setDatatableOptions] = useState({
    draw: 1,
    page: 1,
    recordsTotal: 0,
    recordsFiltered: 0,
    sizePerPage: 20,
    searchText: "",
    sortField: "id",
    sortOrder: "desc",
  });

  useEffect(() => {
    if (loadingListData === true) {
      dispatch(
        UserTypeAction.getUserTypeList(
          getDataTableQuery(datatableOptions, columns),
          props.history
        )
      );
    }
  }, [loadingListData]);

  const [userTypeListData, setUserTypeListData] = useState([]);
  useEffect(() => {
    if (datatableData) {
      setUserTypeListData(datatableData.data);

      const updatedDatatableOptions = {
        ...datatableOptions,
        recordsTotal: datatableData.recordsTotal,
        recordsFiltered: datatableData.recordsFiltered,
      };
      setDatatableOptions(updatedDatatableOptions);

      setLoadingListData(false);
      setLoader(false);
    }
  }, [datatableData]);

  const onTableChange = (type: any, newState: any) => {
    let draw = datatableOptions.draw + 1;
    let page = 1;
    if (type == "search") {
      page = 1;
    } else {
      page = newState.page;
    }
    const updatedDatatableOptions = {
      ...datatableOptions,
      draw: draw,
      page: page,
      sizePerPage: newState.sizePerPage,
      searchText: newState.searchText,
      sortField: newState.sortField,
      sortOrder: newState.sortOrder,
    };
    setDatatableOptions(updatedDatatableOptions);
    setLoadingListData(true);
  };

  const clearFilter = () => {
    const updatedDatatableOptions = {
      ...datatableOptions,
      draw: 1,
      page: 1,
      sizePerPage: 20,
      searchText: "",
      sortField: "id",
      sortOrder: "desc",
    };
    setDatatableOptions(updatedDatatableOptions);
    setLoadingListData(true);
  };
  // Datatable -------------------------------------------------

  // Delete Form --------------------------------------------------------
  const [deleteUserType, setDeleteUserType] = useState({ 
    id: "", 
    user_type_id: "" 
  });
  const [recordName, setRecordName] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (row: any) => {
    const deleteUserTypeData = {
      ...deleteUserType,
      id: row.id,
      user_type_id: row.user_type_id,
    };
    setDeleteUserType(deleteUserTypeData);
    setRecordName(row.user_type_value);
    setDeleteModal(true);
  };
  
  const handleDeleteUserType = () => {
    dispatch(UserTypeAction.deleteUserType(deleteUserType, props.history));
  };
  // Delete Form --------------------------------------------------------

  // Master Form -------------------------------------------------------- 
  const [userTypeData, setUserTypeData] = useState({}); 

  const [masterFormModal, setMasterFormModal] = useState(false);
  const [masterFormModalTitle, setMasterFormModalTitle] = useState("Create user type");

  const onClickModal = () => {
    setUserTypeData('');
    setMasterFormModalTitle("Create user type");
    setMasterFormModal(true);
  };
  
  const onClickEdit = (row: any) => {
    setUserTypeData(row);
    setMasterFormModalTitle("Update user type");
    setMasterFormModal(true);
  }

  const handleSubmitUserType = (values: any) => {
    if(values.id && values.user_type_id){
      dispatch(UserTypeAction.updateUserType(values, props.history));
    }else{
      dispatch(UserTypeAction.createUserType(values, props.history));
    }
  };  
  // Master Form --------------------------------------------------------

  // Messages -------------------------------------------------
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [errorData, setErrorData] = useState({data: {}});

  useEffect(() => {
    if (createUserTypeSuccessMsg) {
      setSuccessMsg(createUserTypeSuccessMsg);
      setLoadingListData(true);
      window.scrollTo(0, 0);
      setErrorMsg("");
      setErrorData({data: {}});
      dispatch(UserTypeAction.createUserTypeSuccess(""));
      setMasterFormModal(false);
    }
  }, [createUserTypeSuccessMsg]);

  useEffect(() => {
    if (createUserTypeErrorMsg) {
      setErrorMsg(createUserTypeErrorMsg);
      setErrorData({data: createUserTypeErrorData});
      window.scrollTo(0, 0);
      setSuccessMsg("");
      dispatch(UserTypeAction.createUserTypeError(""));
    }
  }, [createUserTypeErrorMsg]);

  useEffect(() => {
    if (updateUserTypeSuccessMsg) {
      setSuccessMsg(updateUserTypeSuccessMsg);
      setLoadingListData(true);
      window.scrollTo(0, 0);
      setErrorMsg("");
      setErrorData({data: {}});
      dispatch(UserTypeAction.updateUserTypeSuccess(""));
      setMasterFormModal(false);
    }
  }, [updateUserTypeSuccessMsg]);

  useEffect(() => {
    if (updateUserTypeErrorMsg) {
      setErrorMsg(updateUserTypeErrorMsg);
      setErrorData({data: updateUserTypeErrorData});
      window.scrollTo(0, 0);
      setSuccessMsg("");
      dispatch(UserTypeAction.updateUserTypeError(""));
    }
  }, [updateUserTypeErrorMsg]);

  useEffect(() => {
    if (deleteUserTypeSuccessMsg) {
      setSuccessMsg(deleteUserTypeSuccessMsg);
      setLoadingListData(true);
      window.scrollTo(0, 0);
      setErrorMsg("");
      setErrorData({data: {}});
      dispatch(UserTypeAction.deleteUserTypeSuccess(""));
      setDeleteModal(false);
    }
  }, [deleteUserTypeSuccessMsg]);

  useEffect(() => {
    if (deleteUserTypeErrorMsg) {
      setErrorMsg(deleteUserTypeErrorMsg);
      setErrorData({data: deleteUserTypeErrorData});
      window.scrollTo(0, 0);
      setSuccessMsg("");
      dispatch(UserTypeAction.deleteUserTypeError(""));
      setDeleteModal(false);
    }
  }, [deleteUserTypeErrorMsg]);

  useEffect(() => {
    if (getUserTypeErrorMsg) {
      setErrorMsg(getUserTypeErrorMsg);
      window.scrollTo(0, 0);
      setSuccessMsg("");
      dispatch(UserTypeAction.getUserTypeError(""));
    }
  }, [getUserTypeErrorMsg]);
  // Messages -------------------------------------------------

  return (
    <React.Fragment>

      {deleteUserType && (
        <DeleteModal
          recordName={recordName}
          modalTitle="User Type"
          show={deleteModal}
          onDeleteClick={handleDeleteUserType}
          onCloseClick={() => setDeleteModal(false)}
          loading={loading}
        />
      )}

      {masterFormModal && (
        <UserTypeModal
          modalTitle={masterFormModalTitle}
          show={masterFormModal}
          loading={loading}
          userTypeData={userTypeData}
          onSubmitClick={handleSubmitUserType}
          onCloseClick={() => setMasterFormModal(false)}
          errorMsg={errorMsg}
          errorData={errorData}
        />
      )}

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbTitle="User Type"
            breadcrumbItems={breadcrumbItems}
          />

          <Row>
            <Col xl="12">
              {successMsg ? <Alert color="success">{successMsg}</Alert> : null}
              {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}

              <Card>
                <CardHeader className="bg-transparent border-bottom">
                  <div className="d-sm-flex flex-wrap">
                    <CardTitle className="card-title text-uppercase">
                      User type list
                    </CardTitle>
                    <div className="ms-auto d-flex gap-2">
                      <Link
                        to="#"
                        className="btn btn-primary btn-rounded waves-effect waves-light btn-label"
                        onClick={() => onClickModal()}
                      >
                        <span className="align-middle material-symbols-outlined fw-light fs-4 label-icon">add</span> Create user type
                      </Link>
                      {/* <Button
                        color="primary"
                        className="btn-rounded waves-effect waves-light"
                      >
                        <i className="fa-solid fa-arrows-rotate"></i>
                      </Button> */}
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <DataTable
                    columns={columns}
                    products={userTypeListData}
                    datatableOptions={datatableOptions}
                    filters={[]}
                    onTableChange={onTableChange}
                    loadingListData={loadingListData}
                    clearFilter={clearFilter}
                    slug="masters"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AllUserType;
